export const META_CONSENT_VERSION = "2026-08-08";

export const buildMetaConsentFields = (value) => {
  const consentimientoMeta = value === "si" || value === true;
  return consentimientoMeta
    ? { consentimientoMeta: true, metaConsentVersion: META_CONSENT_VERSION }
    : { consentimientoMeta: false };
};
